import { Button } from "@design";
import { Panel } from "@xyflow/react";
import { Plus, Save } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";

/** The Steps canvas overlays: Add step, Save (with the unsaved-changes note), and the branching hints. */
export function StepsEditorPanels({
  hasSteps,
  dirty,
  saving,
  onAddStep,
  onSave,
}: Readonly<{ hasSteps: boolean; dirty: boolean; saving: boolean; onAddStep: () => void; onSave: () => void }>) {
  const { t } = useTranslation("workflows");
  return (
    <>
      <Panel position="top-left">
        <Button variant="primary" leadingIcon={<Plus size={16} />} onClick={onAddStep}>
          {t("editor.addStep")}
        </Button>
      </Panel>
      <Panel position="top-right">
        <div className="flex items-center gap-3">
          {dirty && (
            <Text variant="body-sm" tone="tertiary">
              {t("editor.unsaved")}
            </Text>
          )}
          <Button
            variant="primary"
            leadingIcon={<Save size={16} />}
            onClick={onSave}
            loading={saving}
            disabled={!dirty}
          >
            {t("editor.saveFlow")}
          </Button>
        </div>
      </Panel>
      {hasSteps && (
        <Panel position="bottom-left">
          <div className="flex flex-col gap-1 rounded-lg border border-border-input bg-surface-primary/90 px-3 py-2">
            <Text variant="caption" tone="tertiary">
              {t("editor.hintFanOut")}
            </Text>
            <Text variant="caption" tone="tertiary">
              {t("editor.hintParallel")}
            </Text>
          </div>
        </Panel>
      )}
    </>
  );
}
